const l = "styles-module__scroller___-viF-", s = {
  "gift-card-carousel": "styles-module__gift-card-carousel___PMqWX",
  scroller: l,
  "scroller-disabled": "styles-module__scroller-disabled___XZgzr"
};
export {
  s as default,
  l as scroller
};
